import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { User } from '../../auth/user.model';
import { Order } from '../order.model';
import { OrderService } from '../order.service';
import { AuthService } from '../../auth/auth.service';
import { UIService } from '../../shared/ui.service';
import { MatDialog } from '@angular/material';
import { MustFillProfileComponent } from '../../reservation/dialog/must-fill-profile/must-fill-profile.component';
import { NeedASwitchComponent } from '../../reservation/dialog/need-a-switch/need-a-switch.component';
import { StorageService } from '../../storage/storage.service';
import { Permission } from '../../access/access.service';

@Component({
  selector: 'app-pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.css']
})
export class PickupComponent implements OnInit, AfterViewInit, OnDestroy {
  user: User;
  orders: Order[];
  isLoading = false;
  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;
  currentProject: number;
  isAdmin: boolean;


  constructor(
    private orderService: OrderService,
    private storageService: StorageService,
    private authentication: AuthService,
    private uiService: UIService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.currentProject = this.storageService.getPreferredProject();
    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.user = this.authentication.getUser();

    this.getPickupOrders();

    this.isAdmin = this.validateAccessToData();

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.currentProject = projectId;
      this.getPickupOrders();
      this.isAdmin = this.validateAccessToData();
    });


  }

  validateAccessToData() {
    return this.authentication.hasAccessToProject(this.currentProject, Permission.ADMIN);
  }

  getPickupOrders() {
    this.uiService.loadingStateChanged.next(true);
    this.orderService.getPickupOrders(this.user.token).subscribe((res: Order[]) => {
        this.orders = res;
        this.uiService.loadingStateChanged.next(false);
    });
  }

  ngAfterViewInit() {

  }

  onReserveContainerClick(event: Event) {
    if (this.user.profile_is_set) {
      this.openReservationDialog();//this.router.navigate(['/reservations/new']);
    } else {
      this.openDialog();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MustFillProfileComponent);
  }

  openReservationDialog(): void {
    const dialogRef = this.dialog.open(NeedASwitchComponent);
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }
}
